import StatusFilter from '@app/store/documents/StatusFilter';

export const PAGINATION_LIMIT = 10;
export const MEMBER_PAGINATION_LIMIT = 10;

// org3
export const MAX_COUNT_OF_ROLES_PER_WORKSPACE = 100;
export const MAX_COUNT_OF_GROUPS_PER_WORKSPACE = 500;
export const MAX_COUNT_OF_MEMBERS_PER_WORKSPACE = 1000;

export const MAX_COUNT_OF_GROUPS_PER_MEMBER = 10;
export const MAX_COUNT_OF_AUTOMATIC_SHARINGS_PER_MEMBER = 20;
export const MAX_COUNT_OF_DEFAULT_AUTOMATIC_SHARINGS_PER_MEMBER = 20;
export const MAX_COUNT_OF_ADDITIONAL_SHARINGS_PER_RESOURCE = 5;

// 문서를 제외한 대량전송, 링크서명, 내부결재 등의 리소스를 의미합니다.
export const MAX_COUNT_OF_LABELS_PER_RESOURCE = 5;
export const MAX_COUNT_OF_LABELS_PER_ONE_TIME_APPLY = 5;

export const SCHEDULED_DOCUMENTS_FILTER_WITHOUT_ARCHIVED = {
  assigned: true,
  limit: 1,
  labelId: null,
  offset: 0,
  status: StatusFilter.SCHEDULED,
};

export const WORKSPACE_MEMBER_INVITATION__KEY = 'invitations';
